module.exports = __webpack_public_path__ + "static/media/face_default.60753899.svg";